import { bsonObjectIdValidator } from '#validation/common/validators';
export const classicFilespaceIdValidator = bsonObjectIdValidator({
    requiredError: 'filespaceMigration.source.classicFilespaceId.format',
    formatError: 'filespaceMigration.source.classicFilespaceId.format',
});
